import React, { FunctionComponent } from "react";

const NotificationBellIcon: FunctionComponent = () => {
  return (
    <svg viewBox="-0.75 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.33337 18.125C8.43922 18.4856 8.65901 18.8022 8.95983 19.0274C9.26066 19.2526 9.62634 19.3743 10.0021 19.3743C10.3779 19.3743 10.7436 19.2526 11.0444 19.0274C11.3452 18.8022 11.565 18.4856 11.6709 18.125"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 2.5V0.625"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 2.5C11.6576 2.5 13.2473 3.15848 14.4194 4.33058C15.5915 5.50268 16.25 7.0924 16.25 8.75C16.25 14.6217 17.5 15.625 17.5 15.625H2.5C2.5 15.625 3.75 14.0283 3.75 8.75C3.75 7.0924 4.40848 5.50268 5.58058 4.33058C6.75268 3.15848 8.3424 2.5 10 2.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NotificationBellIcon;
